<template>
  <div id="content" class="dict_manager">
        <div class="container content_div">
    <h2>Manage Next Steps</h2>

      <table class="table table-stripped" v-if='nextSteps.length >0'>
        <thead class="thead-dark">
          <tr>
            <th>Steps</th>
                      <th >Actions</th>

          </tr>
        </thead>

        <tr v-for="(step, index) in nextSteps" :key="step._id" class="step-item" style="padding:10px;">
          <td>
            <input
              type="text"
              v-model="step.name"
            />
          </td>
          <td>
            <button class="prev_step_btn_small" @click="moveStep(index, -1)" :disabled="index === 0">Up</button>

            <button class="prev_step_btn_small" @click="moveStep(index, 1)" :disabled="index === nextSteps.length - 1">Down</button>


            <button class="btn-remove" @click="deleteStep(step._id.$oid)">Delete</button>

          </td>
      </tr>



    </table>
    <button class="next_step_btn" @click="addStep">Add New Step</button>
    <button class="next_step_btn" @click="saveChanges">Save Changes</button>
  </div>
    </div>
</template>

<script>

import { toast } from 'vue-sonner'
import api from '../../tools/api';
export default {
  data() {
    return {
      nextSteps: [] // This will hold the steps fetched from the database
    };
  },

  methods: {
    // Load steps from the API
    async loadSteps() {
      try {
        const response = await api.get(process.env.VUE_APP_API_URL+'/steps');
        this.nextSteps = response.data;
      } catch (error) {
        console.error("Error loading steps:", error);
      }
    },
    // Add a new step
    async addStep() {
      try {
        let namestep = prompt("Please provide a name for the new step");
        if(namestep){
          const response = await api.post(process.env.VUE_APP_API_URL+'/steps', { name: namestep});
          if (response.data.success) {
            toast.success("Step successfully added");
            this.loadSteps();
          }
        }

      } catch (error) {
        console.error("Error adding step:", error);
      }
    },
    // Save changes to the API
    async saveChanges() {
      try {
        for (let index = 0; index < this.nextSteps.length; index++) {
          const step = this.nextSteps[index];
          await api.put(process.env.VUE_APP_API_URL+`/steps/${step._id.$oid}`, { name: step.name, order: index + 1 });
        }
        toast.success("Steps successfully saved");
        this.loadSteps();
      } catch (error) {
        console.error("Error saving changes:", error);
      }
    },
    // Delete a step
    async deleteStep(id) {
      try {
        if (window.confirm(this.$t("Do you really want to delete this step?"))) {

          await api.delete(process.env.VUE_APP_API_URL+`/steps/${id}`);
          toast.success("Step successfully deleted");
          this.loadSteps();
        }
      } catch (error) {
        console.error("Error deleting step:", error);
      }
    },
    // Move a step up or down
    moveStep(index, direction) {
      const newIndex = index + direction;
      if (newIndex >= 0 && newIndex < this.nextSteps.length) {
        [this.nextSteps[index], this.nextSteps[newIndex]] = [this.nextSteps[newIndex], this.nextSteps[index]];
      }
    }
  },
  mounted() {
    this.loadSteps(); // Load steps when the component is mounted
  }
};
</script>
<style media="screen" scoped>
.dict_manager{
  padding-top:50px;
  padding-bottom: 50px;
}
.content_div{
  /* margin-top:50px;
  margin-bottom: 50px; */
  padding: 50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}



.dict_manager  input,
.dict_manager  select{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: 100%;
height: 40px;
padding: 5px;
}
.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}

.prev_step_btn{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
}

.prev_step_btn_small{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 7px 17px;
  color:#3783C5;
    margin:5px;
}

.btn-remove,
  .btn-remove:hover{
  margin-top:10px;
  margin-bottom:10px;
  color: #FFF !important;
  border-radius: 200px;
  border: 1px solid #b90707;
  padding: 7px 17px;
      margin:5px;
  color: #b90707 !important;
}

@media screen and (max-width: 990px){
  .hidden-sm{
    display:none;
  }
}


.action_zone{
  position: sticky;
    right: 0;
    top: 0;
    background: #4C81C0;
    padding: 20px 50px;
    z-index:889;
    display:flex;
    flex-wrap:wrap;

}
.actionZoneTitle{
  color: #FFF;
  font-weight: bold;
  font-size: 20px;
    text-transform: uppercase;
}

.p-rl-50{
  padding-left:50px;
  padding-right:50px;
}

.action_btn,
.action_btn:hover{
  background: #FFF;
  color: #000;
  padding: 5px 15px;
  font-weight: 600;
  border-radius: 50px;
}
.back_btn,
.back_btn:hover{
  background: #FFF;
  color: #000;
  padding: 10px 25px;
  font-weight: 400;
  border-radius: 50px;
}
.disabledRlink{
  pointer-events: none;
  opacity: 0.7;
}

.zoneBtn{
  position:relative;
  display: flex;

}

.goRight{
  margin-left:auto;
  display:flex;
  flex-wrap:wrap;
  gap:20px;
}

.step-item td{
  padding:10px;
}
</style>
